import { Tooltip } from "@bp/ui-components";
import type { DiagCheck, DiagStatus } from "../../../utils/diagnose";
import { StatusBadge, type StatusKind } from "../../StatusBadge/StatusBadge";
import styles from "./DiagnoseBadges.module.scss";

const TONE: Record<DiagStatus, StatusKind> = { ok: "ok", warn: "warn", err: "err" };

/**
 * The login diagnosis at a glance: one badge per check, the detail as tooltip.
 * Lives in the person header; the full card with fixes only appears when a
 * check fails.
 */
export function DiagnoseBadges({ checks }: { checks: readonly DiagCheck[] }) {
  return (
    <div className={styles.row}>
      {checks.map((c) => (
        <Tooltip key={c.key} content={c.sub} usePortal>
          <span data-testid="diagnose-badge">
            <StatusBadge status={TONE[c.status]} label={c.label} />
          </span>
        </Tooltip>
      ))}
    </div>
  );
}
